module.exports = __webpack_public_path__ + "static/media/img_nav.b1a0edcf.png";